import { Declaration, DeclarationHighValueGroupType, DeclarationStatus, EnvironmentCountries, TransactionTypes } from '@e-origin/shared';

import { CustomsFlow, FinalizeContext, TransactionClass } from './types';

/**
 * The [B2B_HV, B2B_EXPORT, B2B2C_HV, undefined] literal appears 8 times across the frontend,
 * copy-pasted. Named once here.
 */
const B2B_TRANSACTION_TYPES: (TransactionTypes | undefined)[] = [TransactionTypes.B2B_HV, TransactionTypes.B2B_EXPORT, TransactionTypes.B2B2C_HV, undefined];

export const toTransactionClass = (transactionType?: TransactionTypes): TransactionClass => {
  if (B2B_TRANSACTION_TYPES.includes(transactionType)) return 'B2B';
  if (transactionType === TransactionTypes.B2B_MULTIPLE) return 'B2B_MULTIPLE';
  if (transactionType === TransactionTypes.B2C_HV_BEGATE) return 'BEGATE';
  return 'B2C';
};

export const isAmendmentInProgress = (declaration: Declaration): boolean =>
  Boolean(declaration?.messageInfo?.amended?.LRN) && [DeclarationStatus.NOT_SENT, DeclarationStatus.ANALYSIS].includes(declaration?.generalInfo?.status);

interface BuildContextParams {
  declaration: Declaration;
  country: EnvironmentCountries;
  isForwarder: boolean;
  readOnly: boolean;
}

export const buildFinalizeContext = ({ declaration, country, isForwarder, readOnly }: BuildContextParams): FinalizeContext => {
  const group = declaration?.generalInfo?.group as DeclarationHighValueGroupType;
  const flow: CustomsFlow = declaration?.generalInfo?.isExport ? 'EXPORT' : 'IMPORT';

  return {
    country,
    flow,
    group,
    txClass: toTransactionClass(declaration?.transactionType),
    isForwarder,
    isAmendment: isAmendmentInProgress(declaration),
    readOnly,
    declarationMainType: declaration?.messageInfo?.declarationMainType,
  };
};
